import { useQuery } from "@tanstack/react-query";
import { fetchFloorPlanMemoDiagrams } from "~/_legacy/apis/fetch-floor-plan-memo-diagrams";

export const FLOOR_PLAN_MEMO_DIAGRAMS_GROUPED_BY_FLOOR_PLAN_QUERY_KEY =
  "floorPlanMemoDiagramsGroupedByFloorPlan";

export function useGetFloorPlanMemoDiagramsGroupedByFloorPlan({
  branchUid,
  branchVersionId,
  floorPlanIds,
}: {
  branchUid?: string;
  branchVersionId?: number;
  floorPlanIds: number[];
}) {
  return useQuery({
    queryKey: [
      FLOOR_PLAN_MEMO_DIAGRAMS_GROUPED_BY_FLOOR_PLAN_QUERY_KEY,
      branchUid,
      branchVersionId,
      floorPlanIds,
    ],
    queryFn: async () => {
      const entries = await Promise.all(
        floorPlanIds.map(async (floorPlanId) => [
          floorPlanId,
          await fetchFloorPlanMemoDiagrams({ branchUid: branchUid!, branchVersionId, floorPlanId }),
        ])
      );
      return Object.fromEntries(entries);
    },
    enabled: Boolean(branchUid && floorPlanIds.length > 0),
  });
}
